import React, { useState } from 'react';
import Modal from 'react-modal';

const FooterModal = (footerLink) => {

    const [modalStatus, setModalStatus] = useState(false);

    return (
        <div>
            <a onClick={() => setModalStatus(true)}>{footerLink.label}</a>
            <Modal
                isOpen={modalStatus}
                onRequestClose={() => setModalStatus(false)}
                ariaHideApp={false}
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)'
                    },
                    content: {
                        overflow: 'hidden',
                        padding: '0'
                    }
                }}
            >
                <div className="nav-hider">&nbsp;</div>
                <button onClick={() => setModalStatus(false)}>close</button>
                <iframe width="100%" height="100%" src={footerLink.url}></iframe>
            </Modal>
        </div>
    );
}

export default FooterModal;